import Footer from "./common/Footer";
import ContactForm from "./landing/ContactForm";
import { useNavigate } from "react-router-dom";

export const NoviContact = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 w-full z-50 bg-black/70 backdrop-blur border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-start">
          {/* LOGO SECTION */}
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src={require("../img/rakfort.jpeg")}
              alt="RAKFORT"
              className="w-14 h-14 rounded-lg object-cover"
            />
            <span className="font-semibold uppercase tracking-[0.35em] text-[28px] leading-none text-white">
              Novistep
            </span>
          </div>

          {/* NAVIGATION LINKS (bigger + moved left) */}
          <div className="hidden md:flex items-center gap-8 text-lg font-semibold text-white ml-8">
            <span
              onClick={() => navigate("/jobsuite")}
              className="hover:text-yellow-400 cursor-pointer transition-colors"
            >
              JobStep
            </span>
            <span
              onClick={() => navigate("/studysuite")}
              className="hover:text-yellow-400 cursor-pointer transition-colors"
            >
              StudyStep
            </span>
            <a href="#faq" className="hover:text-yellow-400 transition-colors">
              FAQs
            </a>
          </div>
        </div>
      </nav>

      {/* PAGE CONTENT */}
      <div className="min-h-screen flex flex-col bg-[#fafafa] pt-[88px]">
        <ContactForm />
        <Footer />
      </div>
    </>
  );
};
